export default __webpack_public_path__ + "static/media/update-field-modal.5d37d687.svg";